export default __webpack_public_path__ + "static/media/wearMasks.5b51f9a6.jpeg";